export const PROMO_STATUS_VALUES = {
  PROMOTE: 'PROMOTE',
  NO_CHANGE: 'NO_CHANGE',
  PIP: 'PIP',
  FUTURE_PROMOTE: 'FUTURE_PROMOTE',
};

export const PROMO_STATUS_LABELS = {
  [PROMO_STATUS_VALUES.PROMOTE]: 'Promote',
  [PROMO_STATUS_VALUES.NO_CHANGE]: 'No Change',
  [PROMO_STATUS_VALUES.PIP]: 'PIP',
  [PROMO_STATUS_VALUES.FUTURE_PROMOTE]: 'Future Consideration',
};

export const PROMO_STATUS_COLORS = {
  [PROMO_STATUS_VALUES.PROMOTE]: 'green',
  [PROMO_STATUS_VALUES.NO_CHANGE]: 'yellow',
  [PROMO_STATUS_VALUES.PIP]: 'red',
  [PROMO_STATUS_VALUES.FUTURE_PROMOTE]: 'blue',
};
